export default __webpack_public_path__ + "static/media/img_8.615df04c.jpg";